const regionFragment = `
{
  copy,
  place,
  title
}
`;

export default regionFragment;
